export type BadgeTone =
  | 'green'
  | 'amber'
  | 'rose'
  | 'blue'
  | 'violet'
  | 'gray'
  | 'danger'
  | 'warn'
  | 'success';

export type StatusBadgeProps = {
  /** Explicit active/inactive mode. When set, overrides `label`/`tone`. */
  active?: boolean;
  /** Free-form label when not using the boolean mode. */
  label?: string;
  tone?: BadgeTone;
};

/**
 * The two display modes from the prototype:
 *   <StatusBadge active={true|false} />
 *   <StatusBadge label="Qualified" tone="amber" />
 */
export function StatusBadge({ active, label, tone = 'gray' }: StatusBadgeProps) {
  if (active !== undefined) {
    return (
      <span className={`badge ${active ? 'green' : 'rose'}`}>
        <span className="badge-dot" />
        {active ? 'Active' : 'Inactive'}
      </span>
    );
  }
  return (
    <span className={`badge ${tone}`}>
      <span className="badge-dot" />
      {label}
    </span>
  );
}
